// extracted by mini-css-extract-plugin
export var divider = "_xd-0";